"use client";

import { useEffect, useState } from "react";
import ContactUsCard from "../contactUs/ContactUsCard";
import HubSpotForm from "../contactUs/HubSpotForm";


interface Props {
  customClasses?: string;
}


export default function MoreInformationButton({
  customClasses = "",
}: Props) {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);
  const defaultClasses =
    "px-10 py-3.5 text-base rounded-[4px]";

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  }, [isOpen]);

  return (
    <>
      <div className="px-5 md:px-10 flex justify-center mt-10">
        <button
          type="button"
          onClick={openModal}
          className={`inline-flex items-center justify-center hover:bg-yellow02 text-roboto font-bold text-dark02 bg-matco transition-colors ${customClasses || defaultClasses}`}
        >
          Hablar con un especialista
        </button>
      </div>

      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm p-4 transition-all">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-6xl max-h-[90vh] overflow-hidden flex flex-col relative border border-gray-200">
            {/* Modal Header */}
            <div className="bg-white px-6 py-5 flex justify-between items-center border-b-4 border-matco">
              <h3 className="text-xl font-bold  uppercase tracking-wider">
                Hablar con un especialista
              </h3>
              <button
                onClick={closeModal}
                className="text-gray-400 hover:text-white transition-colors  hover:bg-gray-700 rounded-full p-1.5"
                aria-label="Cerrar modal"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            
            {/* Modal Body */}
            <div className="overflow-y-auto p-4 md:p-8 bg-gray-50">
              <section className="container mx-auto flex flex-col lg:flex-row gap-8">
                 <HubSpotForm />
                  <div className="w-full lg:w-1/2 xl:w-1/3 hidden lg:block">
                    <ContactUsCard />
                  </div>
              </section>
            </div>
          </div>
        </div>
      )}
    </>
  );
}